import styles from "../../../assets/styles/AuthComponents.module.scss";
import AuthService from "../../../api/services/auth.service";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setCookie } from "../../../utils/cookies";
import { useAuth } from "../../../context/AuthContext";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import Input from "../../../components/common/input/Input";
import { useTranslation } from "react-i18next";

const Otp = () => {
  const { t } = useTranslation("translation");
  const [errorMessage, setErrorMessage] = useState("");
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { email } = useAuth();

  const validateOtp = (value: string) => {
    if (!value) {
      return t("required.verify_code");
    }
    if (!/^\d{6}$/.test(value)) {
      return t("required.code_digits");
    }
    return "";
  };

  const handleOtpChange = (value: string) => {
    setOtp(value);
    setOtpError(validateOtp(value));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const error = validateOtp(otp);
    if (error) {
      setOtpError(error);
      return;
    }
    setIsLoading(true);
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("otp", otp);
      formData.append("email", email);
      const res = await AuthService.sendOtp(formData);
      if (res.data) {
        if (res.data.access_token) {
          setCookie("StoreDashboardAccessToken", res.data.access_token);
        }
        navigate("/dashboard");
      }
    } catch (error: any) {
      setIsLoading(false);
      setErrorMessage(
        error.response.data.message ||
          error.response.data.error ||
          t("error_message"),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("email", email);
      await AuthService.resendOtp(formData);
      setErrorMessage(t("otp.message") || "");
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        t("error_message");
      setErrorMessage(message);
    }
  };

  return (
    <div className={styles.container}>
      <TitleUpdater title={t("otp.title")} />
      <form className={styles.form} onSubmit={handleSubmit}>
        <div>
          <h2 className={styles.title}>{t("otp.section_title")}</h2>
          <p className={styles.subtitle}>
            {t("otp.subtitle")} {email}
          </p>
        </div>
        {errorMessage && (
          <div
            className={
              errorMessage.includes("resent")
                ? styles.successMessage
                : styles.errorMessage
            }
          >
            {errorMessage}
          </div>
        )}
        <div>
          <Input
            label={t("labels.otp_code") || ""}
            placeholder={t("placeholders.otp_code") || ""}
            value={otp}
            onChange={(e) => handleOtpChange(e.target.value)}
            error={otpError}
            maxLength={6}
          />
          <p className={styles.info}>{t("otp.otp_code_message")}</p>

          <p className={styles.resend}>
            {t("otp.code_not_received")}
            <span className={styles.resendLink} onClick={handleResendOtp}>
              {t("buttons.resend")}
            </span>
          </p>
        </div>
        <button
          type="submit"
          className={styles.button}
          disabled={isLoading || !!otpError}
        >
          {isLoading ? t("buttons.verifying") : t("buttons.otp_verify")}
        </button>

        <div className={styles.account}>
          {t("login.have_account")}
          <Link to={"/auth/login"} className={styles.link}>
            {t("buttons.login")}
          </Link>
        </div>
      </form>
    </div>
  );
};

export default Otp;
